import { TUser } from 'shared/map-search/types/user';

import { TTrackingUser } from '../../types/cianAnalyticsPageViewObject';

interface IGetTrackingUserParams {
  user: TUser;
  regionId?: null | number;
}

export const getTrackingUser = ({ user, regionId }: IGetTrackingUserParams): TTrackingUser => {
  const extra = { defaultRegionId: regionId };

  if (user && user.isAuthenticated) {
    return {
      userId: user.userId,
      extra,
    };
  }

  return {
    extra,
  };
};
